import { EXPLORER_API } from '../utils/constants';

export abstract class ExplorerApi {
  /**
   * Get the party information.
   *
   * @param [partyId] - The party ID/
   * @returns A promise that resolves with the party information.
   */
  static async getUpdates(partyId: string, limit = 20): Promise<any> {
    const req = await fetch(
      `${EXPLORER_API}/v2/parties/${partyId}/updates?limit=${limit}`,
    );
    const body = await req.json();

    return body;
  }
}
